import { TcClickTypes } from 'src/configuration/tagcommander'

import { ActionButtonProps } from '../../components/ActionButton'
import { PlanningMenuSectionProps } from '../../components/PlanningMenuSection'
import tcClick from '../tcClick/tcClick'

export const planningMenuTransformer = (
  menuTitle: string,
  items: PlanningMenuSectionProps['items'],
  t: any,
  onSuggestCtaClick?: () => void,
  menuWillBeHidden?: boolean,
  tcVars?: {
    chapter1: string
    chapter2: string
    chapter3: string
  }
): PlanningMenuSectionProps => {
  return {
    title: menuTitle,
    items,
    fallback:
      menuWillBeHidden || !items
        ? {
            noMenuText: t('planning_menu_no_menu'),
            // suggestionText: t('planning_menu_suggestion_message', {
            //   ingredientFirstChoiceCategory: t(
            //     'planning_menu_suggestion_message_ingredient_first_choice_category'
            //   ),
            //   ingredientFirstChoiceName: t(
            //     'planning_menu_suggestion_message_ingredient_first_choice_name'
            //   ),
            // }),
            // changeMindText: t('planning_menu_change_my_mind'),
            menuButtonProps: {
              text: t('planning_menu_suggest_cta'),
              variantType: 'button',
              variantColorScheme: 'black',
              actionProps: {
                onClick: () => {
                  tcVars &&
                    tcClick({
                      click_name: `${t('planning_menu_suggest_cta')}_fam`,
                      click_type: TcClickTypes.action,
                      chapter1: tcVars.chapter1,
                      chapter2: tcVars.chapter2,
                      chapter3: tcVars.chapter3,
                    })
                  onSuggestCtaClick?.()
                },
              },
            } as ActionButtonProps,
          }
        : undefined,
  }
}
